import React, { useState, useEffect } from 'react';
import { CustomModalWeek } from './customModal';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { sortTasksByTime } from '../../functions/date/getFirstLastDay'; // Adapter selon tes fonctions
import { useConf } from '../../context/account/paramsAccount';
import { useError } from '../../context/erreur/erreurContext';
import { hookApi } from '../../hook/presta/affichePrestaHook';
import { CustomColorWeekItem } from '../../functions/date/colorofTask/colorTask';
import { Link } from 'react-router-dom';
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";
import { apiPostWToken } from '../../api/apiPost';

const hours = [
    '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '22:00', '00:00'
];
const columns = [
    { field: "soc_nom", header: "Nom de la société", width: "30%" },
    { field: "sit_nom", header: "Nom site", width: "30%" },
];

const DayAgenda = () => {
    const { conf, setConf }: any = useConf();
    const { showError } = useError();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [tasks, setTasks]: any = useState([]);
    const [sortedTasks, setSortedTasks] = useState<{ [key: string]: any[] }>({});
    const [selectedTask, setSelectedTask] = useState<any | null>(null);
    const [newDate, setNewDate]: any = useState(null);
    interface Site {
        sit_couleur: null
        sit_id: number
        sit_nom: string
        soc_id: number
        soc_nom: string
        v_ordre: string
    }

    const [site, setSite] = useState<Site | null>(null);
    const [dataTab, setDataTab] = useState([])
    const allSitesOption = { sit_nom: "Tous les sites", soc_id: null, soc_nom: "Tous les sites", sit_id: null };
    const fullDataTab = [allSitesOption, ...dataTab];

    useEffect(() => {
        if (conf?.user?.site?.soc_id) {
            setSite(conf.user.site);
        }
    }, [conf?.user?.site?.soc_id]);
    useEffect(() => {
        const data = null
        if (conf.token !== '' && conf.token !== undefined) {
            apiPostWToken("/posts/choix-site", data, conf.token, conf, setConf, showError).then((response: any) => {
                setDataTab(response)
            })
        }
    }, [conf.token])
    useEffect(() => {
        if (!conf.token || !site) return;
        const dateData = {
            e_date_deb: (selectedDate),
            e_date_fin: (selectedDate),
            e_soc_id: site?.soc_id,
            url: conf.user.url,
        };
        hookApi('/posts/planning', dateData, conf, setConf, setNewDate, showError);

    }, [selectedDate, conf.token, site]);

    useEffect(() => {
        if (newDate !== null) {
            const processedData = newDate;
            const dayTasks = sortTasksByTime(processedData);
            const tasksByHour = hours.reduce((acc, hour) => {

                acc[hour] = dayTasks?.filter((task: any) => (

                    new Date(task.v_hdate_debut).getHours() === parseInt(hour.split(':')[0]))
                );
                return acc;
            }, {} as { [key: string]: any[] });

            setTasks(dayTasks);
            setSortedTasks(tasksByHour);
        }
    }, [newDate]);

    const handleTaskClick = (task: any) => {
        const formattedTask = {
            ...task,
            start: new Date(task.v_hdate_debut),
            end: new Date(task.v_hdate_fin)
        };

        setSelectedTask(formattedTask);
    };
    const handleCloseModal = () => {
        setSelectedTask(null);
    };

    function changeDate(value: Date) {
        setSelectedDate(value);
    }

    return (
        <div>
            <div className="containerDatePicker">
                <div className='datePicker'>
                    <div>
                        <MultiColumnComboBox
                            data={fullDataTab}
                            columns={columns}
                            textField={"sit_nom"}
                            placeholder={conf?.user?.site?.sit_nom ? conf.user?.site?.sit_nom : "Selectionnez une valeur"}
                            onChange={(e: any) => { setSite(e.value) }} />
                    </div>
                    <LocalizationProvider language="fr-FR">
                        <IntlProvider locale="fr">
                            <DatePicker
                                defaultValue={selectedDate}
                                onChange={(e: any) => changeDate(e.target.value)}
                            />
                        </IntlProvider>
                    </LocalizationProvider>
                </div>
                <div className='weekLink'>
                    <Link className='buttonChangeCalendarMonth' to='/planning/semaine'>Semaine</Link>
                    <Link className='buttonChangeCalendarMonth' to='/planning'>Mois</Link>
                    <Link className='buttonChangeCalendarMonth semaine' to='/planning/jour'>Jour</Link>
                </div>
            </div>

            <div className="dayAgendaContainer">
                <div className="hoursColumn">
                    {hours.map((hour) => (
                        <div key={hour} className="hourLabel">
                            {hour}
                        </div>
                    ))}
                </div>

                <div className="tasksColumn">
                    {hours.map((hour) => (
                        <div key={hour} className="hourRow">
                            {(sortedTasks[hour] || []).map((task: any) => {
                                const { pastilleColor } = CustomColorWeekItem(task);
                                return (
                                    <li key={task.id} className='taskDay' onClick={() => handleTaskClick(task)}>

                                        <div className='headerTaskDay'>
                                            <span style={{ color: 'rgb(150, 189, 13)', fontWeight: 'bold' }}>
                                                {new Date(task.v_hdate_debut).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                            </span>
                                            <span>
                                                {task.v_num_piece}
                                            </span>
                                        </div>
                                        <div className='bodyTaskDay'>
                                            <span style={{ color: 'blue', fontWeight: 'bold' }}>
                                                {task.v_desc}
                                            </span>
                                            <span style={{ color: 'purple', fontWeight: 'italic' }}>
                                                {task.v_lib_avancement}
                                            </span>
                                            <span style={{ color: 'black', fontWeight: 'bold' }}>
                                                {task.v_cli_civ_nom}
                                            </span>
                                            <span style={{ color: 'red', fontWeight: '900' }}>
                                                {task.modeVente}
                                            </span>

                                            <span className="pastilleweek" style={{ backgroundColor: pastilleColor }}></span>
                                        </div>
                                        <div className='footerTaskDay'>
                                            <span>
                                                {task.v_lieu_civ_nom}
                                            </span>

                                            {
                                                task.v_nbre_convive === null ?
                                                    "" : <span>{task.v_nbre_convive}personnes</span>
                                            }
                                        </div>
                                    </li>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>

            {selectedTask && (
                <>
                    <div className="overlay"></div>
                    <div className="modalDC" onClick={handleCloseModal} >
                        <div className="titleContainer">
                            <div className='backgroundDC'>
                                <CustomModalWeek dataItem={selectedTask} onClose={handleCloseModal} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default DayAgenda;
